import React from "react";
const UI_VERSION = import.meta.env.VITE_UI_VERSION;
import { Link } from "react-router-dom";

let today = new Date();
export default function AppFooterView({ version }) {
  return (
    <footer
      className="app-footer"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <span>
        &copy; {today.getFullYear()} Vision Insights |{" "}
        <span>
          <Link to="privacy-policy">Privacy Policy</Link>
        </span>
        {version?.api && ` | API ${version.api}`}
        {UI_VERSION && ` | UI ${UI_VERSION}`}
      </span>

      <span>
        Having issues with the app? Email an issue report to{" "}
        <a
          href="mailto:decoderhelp@visioninsights.net"
          style={{
            color: "var(--highlight-primary-1)",
            textDecoration: "underline",
          }}
        >
          decoderhelp@visioninsights.net
        </a>
      </span>
    </footer>
  );
}
